import React from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import What from "./Components/What";
import Why from "./Components/Why";
import How from "./Components/How";
import Solution from "./Components/Solution";

function App() {
  return (
    <div>
      <Header />
      <What />
      <Why />
      <How />
      <Solution />
      <Footer />
    </div>
  );
}

export default App;
